export const bfhimages24 = [
    "https://static.igem.wiki/teams/5247/photos/meetup/chekin.jpeg",
    "https://static.igem.wiki/teams/5247/photos/meetup/joern.jpeg",
    "https://static.igem.wiki/teams/5247/photos/meetup/affe.jpeg",
    "https://static.igem.wiki/teams/5247/photos/meetup/orgateam.jpeg",
    "https://static.igem.wiki/teams/5247/photos/meetup/uni.jpeg",
    "https://static.igem.wiki/teams/5247/photos/meetup/bye1.jpeg",
    "https://static.igem.wiki/teams/5247/photos/meetup/kristian.jpeg",
    "https://live.staticflickr.com/65535/54818174539_64e3358709_b.jpg",
    "https://live.staticflickr.com/65535/54818269930_88a8ed529f_b.jpg",
    "https://live.staticflickr.com/65535/54818196618_60524ffd90_b.jpg",
    "https://static.igem.wiki/teams/5247/photos/meetup/exhibition/posterexhibition-plasmid-factory.webp",
    "https://static.igem.wiki/teams/5247/photos/meetup/exhibition/posterexhibition-frankfurt.webp",
    "https://static.igem.wiki/teams/5247/photos/meetup/exhibition/posterexhibition-air-view.webp",

    "https://static.igem.wiki/teams/5033/images/human-practices/bielefeld.jpg",
    "https://static.igem.wiki/teams/5088/wiki/images/season-gallery/a026.webp",
    "https://static.igem.wiki/teams/5088/wiki/images/season-gallery/a025.webp",
    "https://static.igem.wiki/teams/5088/wiki/images/season-gallery/a036.webp",

    "https://static.igem.wiki/teams/5295/bfh/02-big-group-picture.webp",
    "https://static.igem.wiki/teams/5295/bfh/05-workshop-kolland.webp",
    "https://static.igem.wiki/teams/5295/bfh/08-workshop-sci-comm.webp",
    "https://static.igem.wiki/teams/5295/bfh/09-workshop-groening.webp",
    "https://static.igem.wiki/teams/5295/bfh/10-workshop-xyna.webp",
    "https://static.igem.wiki/teams/5295/bfh/14-sci-talks-shankar.webp",
    "https://static.igem.wiki/teams/5295/bfh/16-pep-talk-lasse.webp",
    "https://static.igem.wiki/teams/5295/bfh/20-sci-slam-vasquet.webp",
    "https://static.igem.wiki/teams/5295/bfh/30-special-thanks-frankfurt.webp",
    "https://static.igem.wiki/teams/5295/bfh/29-committee.webp",

    "https://static.igem.wiki/teams/5077/education-pictures/bfh-2.webp"
]